import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { get as _get } from 'lodash';
import { AnalyticsService } from './@core/utils/analytics.service';
import { AppService } from '@app-services/app.service';
import {select, Store} from '@ngrx/store';
import * as fromAuth from '@app-stores/reducers/auth';
import * as Auth from '@app-stores/actions/auth.action';
import { PtySocketService } from '@app-services/pty-socket.service';
import { NbToastrService, NbGlobalPosition, NbGlobalPhysicalPosition } from '@nebular/theme';
import { NbComponentStatus } from '@nebular/theme';
import {HttpClient} from "@angular/common/http";
import { APIs } from '@app-settings/index';
import { HttpHeaderService } from '@app-services/http-header.service';
import {catchError, takeUntil} from 'rxjs/operators';
import { throwError } from 'rxjs';
import { CrmUser, UserMinimal } from '@app-models/index';

import {of} from "rxjs";
import { getUser } from "@app-stores/reducers/auth";
import {ActivatedRoute} from "@angular/router";
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localeAr from '@angular/common/locales/ar';
import localeZh from '@angular/common/locales/zh';
import localeFr from '@angular/common/locales/fr';
import localeHi from '@angular/common/locales/hi';
import localeId from '@angular/common/locales/id';
import localePt from '@angular/common/locales/pt';
import localeRu from '@angular/common/locales/ru';
import {TranslationService} from "@app-services/translation.service";
import {parse} from "jasmine-spec-reporter/built/configuration-parser";
registerLocaleData(localeEs);
registerLocaleData(localeAr);
registerLocaleData(localeZh);
registerLocaleData(localeFr);
registerLocaleData(localeHi);
registerLocaleData(localeId);
registerLocaleData(localePt);
registerLocaleData(localeRu);

@Component({
	selector: 'ngx-app',
	template: '<router-outlet></router-outlet>',
	styleUrls: ['./app.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit, OnDestroy {
	private _viewInit = false;
	private _unsubscribeAll: Subject<any>;
	// Toastr setting
	private _duration = 2000;
	private _position: NbGlobalPosition = NbGlobalPhysicalPosition.TOP_RIGHT;
	private _preventDuplicates = false;
	getLoggedIn$ = this._store.pipe(select(fromAuth.getLoggedIn));
	getLanguageSelected$ = this._store.pipe(select(fromAuth.getLanguageSelected));
	getLogout$ = this._store.pipe(select(fromAuth.getLogout));
	getUser$ = this._store.pipe(select(getUser));
	getLoginWithToken$ = this._store.pipe(select(fromAuth.getLoginWithToken));
	user: CrmUser = null;
	constructor(
		private _analytics: AnalyticsService,
		private _appService: AppService,
		private _store: Store<fromAuth.AuthState>,
		private _webSocket: PtySocketService,
		private _toastrService: NbToastrService,
		private _httpClient: HttpClient,
		private _httpHeaderService: HttpHeaderService,
		private _route: ActivatedRoute,
		private _translationService: TranslationService
	) {
		// debugger;
		this._unsubscribeAll = new Subject();
	}
	ngOnInit(): void {
		let self = this;
		const accessToken = localStorage.getItem('access_token');
		let localUser: any = localStorage.getItem('user');
		/*
		this.getLoggedIn$.pipe(takeUntil(this._unsubscribeAll)).subscribe((loggedIn) => {
			if (accessToken && !loggedIn) {
				location.reload();
			}
		});
		 */
		this.getUser$.pipe(takeUntil(this._unsubscribeAll)).subscribe((user) => {
			if(user === null) {
				return;
			}

			const user_parsed = {...user};
			this.user = user_parsed;
			// Read the token here rather than reusing the const captured at ngOnInit, so a token
			// refreshed since then is the one the socket authenticates with. With no token the
			// server would reject the handshake and socket.io would retry forever, so don't start.
			const socketToken = localStorage.getItem('access_token');
			if (socketToken) {
				this._webSocket.connect(user_parsed, socketToken);
			}
			this._webSocket.listen('crm_notification').subscribe((data) => {
				self.showToast('success',  self._translationService.translate('Settings.Notification'), self._translationService.translate('Common.You have received notification'), 8000);
			});
			this._webSocket.listen('adminOmConversation:message:newMessages').subscribe((data: UserMinimal) => {
				self.showToast(
					'success',
					self._translationService.translate('Common.NewMessage'),
					self._translationService.translate('Common.NewMessageFromOm') + " " + data.first_name + " " + data.last_name,
					8000
				);
			});
			this._webSocket.listen('adminConversation:message:newMessages').subscribe((data) => {
				self.showToast(
					'success',
					self._translationService.translate('Common.NewMessage'),
					self._translationService.translate('Common.NewMessageFromLeader'),
					8000
				);
			});
			this._webSocket.listen('adminOmConversation:message:unreadCount').subscribe(unreadCount => {
				if (typeof unreadCount === 'string') {
					unreadCount = parseInt(unreadCount);
				}
				if (typeof unreadCount === 'number') {
					this._appService.setAdminOmMessageUnreadSub.next(unreadCount);
				}
			});
			this._webSocket.listen('adminConversation:message:unreadCount').subscribe(unreadCount => {
				if (typeof unreadCount === 'string') {
					unreadCount = parseInt(unreadCount);
				}
				if (typeof unreadCount === 'number') {
					this._appService.setAdminMessageUnreadSub.next(unreadCount);
				}
			});
		});
		this.getLogout$.pipe(takeUntil(this._unsubscribeAll)).subscribe((isJustLoggedOut) => {
			if (!isJustLoggedOut) {
				return;
			}

			// TODO: Refactor this to reloading translations
			location.reload();
		});
		const loadPreferredTranslation = (user) => {
			this.getPreferredTranslation(user.crm_language_id, () => {
				if (localUser) {
					try {
						localUser = JSON.parse(localUser);
						if (user.crm_language_id !== localUser.crm_language_id) {
							location.reload();
						}
					} catch (err) {

					}
				} else {
					location.reload();
				}
			});
		};
		// This block handled loading translations upon normal login
		this.getLanguageSelected$.pipe(takeUntil(this._unsubscribeAll)).subscribe((languageSelected) => {
			if (!languageSelected) {
				return;
			}

			loadPreferredTranslation(this.user);
		});
		// This block handles loading translations on login with token (i.e. page refresh while logged in)
		this.getLoginWithToken$.pipe(takeUntil(this._unsubscribeAll)).subscribe( (state) => {
			if (!state.loginWithToken) {
				return;
			}

			this.user = state.user;

			loadPreferredTranslation(this.user);
		});

		if (accessToken) {
			this.verifySessionFromApi(accessToken)
				.pipe(catchError((error) => {
					this.initLoginScreenTranslations();
					return throwError('Verifying session');
				}))
				.subscribe((res: any) => {
					if (res.success === true) {
						this._appService.accessToken = accessToken;
						this._store.dispatch(new Auth.LoginWithToken(null));
						this._analytics.trackPageViews();
					}
				}, (err: any) => {
					this.initLoginScreenTranslations();
					console.error('Translation not loaded', err);
				});
		} else {
			this.initLoginScreenTranslations();
		}
	}
	ngOnDestroy() {
		// Unsubscribe from all subscriptions
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}
	private initLoginScreenTranslations() {
		// Load translations when the user is not logged in

		// this._route.snapshot.queryParamMap.get('lang') always returning null
		let languageCode = null;
		if (location && location.search) {
			const params = location.search.substr(1).split('&');
			for (const i in params) {
				const param = params[i].split('=');
				if (param[0] === 'lang') {
					languageCode = param[1];
				}
			}
		}

		let locale = 'en';
		if (languageCode) {
			locale = languageCode.substr(0, 2).toLowerCase();
		} else if (navigator) {
			locale = navigator.language;
			locale = locale.substr(0, 2).toLowerCase();
		} else {
			locale = 'en';
		}
		console.log(locale);
		this.getPreferredTranslation(locale, () => {});
	}
	private showToast(type: NbComponentStatus, title: string, body: string, duration: number = null) {
		if (duration === null) {
			duration = this._duration;
		}
		const config = {
			status: type,
			destroyByClick: true,
			duration: duration,
			hasIcon: true,
			position: this._position,
			preventDuplicates: this._preventDuplicates,
		};
		const titleContent = title ? `. ${title}` : '';
		this._toastrService.show(body, `${titleContent}`, config);
	}

	getDefaultTranslation(callback) {
		const self = this;
		let lang = 'en';

		return self.fetchTranslationsFromApi(lang)
			.pipe(catchError((error) => {
				return throwError('Loading translations from disk');
			}))
			.subscribe((res: any) => {
			if (res.success === true) {
				const crm_translation = res.data[0].crm_translations;
				if (crm_translation !== null) {
					this.storeTranslations(lang, crm_translation);
				}
			}
			callback();
		}, (err: any) => {
			console.error('Translation not loaded', err);
			callback();
		});
	}

	getPreferredTranslation(id, callback) {
		const self = this;
		self.fetchTranslationsFromApi(id)
			.pipe(catchError((error) => {
				return throwError('Loading translations from disk');
			}))
			.subscribe((res: any) => {
			if (res.success === true) {
				const defaultTranslation = require('../assets/i18n/en.json');
				let crm_translation = res.data[0].crm_translations;
				crm_translation = this.copyDeeper(defaultTranslation, crm_translation);
				if (crm_translation !== null && JSON.stringify(crm_translation) !== localStorage.getItem('crm_translation')) {
					this.storeTranslations(id, crm_translation);
					location.reload();
					callback();
				} else if (crm_translation === null) {
					this.getDefaultTranslation(callback);
				} else {
					localStorage.setItem('translationLanguage', JSON.stringify(id));
					callback();
				}
			} else {
				this.getDefaultTranslation(callback);
			}
		}, (err: any) => {
			console.error('Translation not loaded', err);
			callback();
		});
	}

	fetchTranslationsFromApi(id) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers) {
			let api = APIs.crm_translation + '/' + id;

			return this._httpClient.get(api);

		}
		let api = APIs.crm_translation + '/' + id;
		return this._httpClient.get(api, {headers: headers});
	}

	verifySessionFromApi(accessToken) {
		const headers = this._httpHeaderService.getHttpHeader(accessToken);
		let api = APIs.auth_verify_session;
		return this._httpClient.post(api, {headers: headers});
	}

	storeTranslations(language, crm_translation) {
		const defaultTranslation = require('../assets/i18n/en.json');
		if (localStorage.getItem('crm_translation')) {
			localStorage.removeItem('crm_translation');
		}
		crm_translation = this.copyDeeper(defaultTranslation, crm_translation);
		localStorage.setItem('crm_translation', JSON.stringify(crm_translation));
		localStorage.setItem('translationLanguage', JSON.stringify(language));
	}

	protected copyDeeper(source, target) {
		const newObj = {...source};
		for (const i in target) {
			if (!target.hasOwnProperty(i)) {
				continue;
			}

			if (newObj.hasOwnProperty(i)) {
				newObj[i] = {...newObj[i], ...target[i]};
			} else {
				newObj[i] = {...target[i]};
			}
		}
		return newObj;
	}
}
